import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useToast } from '@kanda-libs/ks-design-library';
import { useCurrentUser, useSignIn } from '@kanda-libs/ks-frontend-services';

import { URLS } from 'config';
import { selectors } from 'store';

import { getError } from './StaffLogin-functions';

const ContainerComponent = ({ children }) => {
  const user = useSelector(selectors.getUser);

  const { isUserLoggedIn, isValidating, revalidate } = useCurrentUser();
  const { mutate: googleSignIn, isLoading: signInIsSubmitting } =
    useSignIn('googlePopup');

  const { push } = useHistory();

  const { showError } = useToast();

  const signInWithGoogle = useCallback(() => {
    googleSignIn(false).then(({ error: signInError }) => {
      if (signInError) {
        showError(getError(signInError));
      }

      setTimeout(() => {
        revalidate();
      }, 1000);
    });
  }, [googleSignIn, showError, revalidate]);

  /**
   * This useEffect call will listen for the current user state. If the user is logged in
   * it will redirect them either to / or /staff depending on their role.
   */
  useEffect(() => {
    if (isValidating || !isUserLoggedIn || !user) return;

    if (user.role === 'staff') {
      push(URLS.staff);
      return;
    }

    push(URLS.home);
  }, [isUserLoggedIn, isValidating, push, user]);

  const isSubmitting = signInIsSubmitting;

  const disabled = isSubmitting;

  return children({
    signInWithGoogle,
    disabled,
    isSubmitting,
  });
};

ContainerComponent.displayName = 'StaffLogin-container';

export default ContainerComponent;
